import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 * @property {HTMLElement} playPauseBtn - The play/pause button.
 */

export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement, playPauseBtn } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;
      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();

    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', () => {
        if (videoElement.paused) {
          videoElement.play();
          playPauseBtn.innerHTML = '⏸';
          playPauseBtn.setAttribute('aria-label', 'Pause video');
        } else {
          videoElement.pause();
          playPauseBtn.innerHTML = '▶';
          playPauseBtn.setAttribute('aria-label', 'Play video');
        }
      });
    }
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
